import dayjs from "dayjs";
import { LabeledFilter } from "./createFilterStore";

const serializeValue = (
  value: unknown,
  isDate?: boolean,
  operator?: string,
) => {
  if (operator === "null" || operator === "notNull") {
    return undefined;
  }

  if (isDate) {
    if (dayjs.isDayjs(value)) {
      return value.toISOString().replace("Z", "");
    } else if (typeof value === "string") {
      return value.replace("Z", "");
    }
  } else if (typeof value === "string") {
    if (value === "true") {
      return true;
    } else if (value === "false") {
      return false;
    }
  }

  return value;
};

export const getQueryFromFilter = (
  filters: Record<string, LabeledFilter>,
  predicateType: "and" | "or" = "and",
) => {
  const predicates = Object.values(filters).map((filter) => {
    return {
      property: filter.field,
      type: filter.operator,
      value: serializeValue(
        filter.value,
        filter.labelInfo?.isValueDate,
        filter.operator,
      ),
    };
  });

  if (predicates.length === 0) {
    return [];
  }

  const predicateObject = {
    type: predicateType,
    predicates,
  };

  const query = [
    {
      field: "predicate",
      value: JSON.stringify(predicateObject),
    },
  ];

  return query;
};
